<template>
  <v-card outlined>
    <v-card-title>
      <span class="py-1 primary--text">{{ formEditTitle }}</span>
    </v-card-title>
    <v-card-text class="pb-2">
      <v-form
        v-model="isFormValid"
        ref="form"
        form="form"
        id="form"
        @submit.prevent="save()"
      >
        <v-row>
          <v-col cols="5" class="py-0 pt-0">
            <v-select
              v-model="tiposNotasSelected"
              :items="tiposNotasItems"
              label="Tipo de nota"
              return-object
              clearable
              item-text="value"
              :rules="rules.required"
              item-value="id"
              outlined
              dense
            >
            </v-select>
          </v-col>
          <v-col cols="4" class="py-0">
            <v-text-field
              v-model="tituloNota"
              dense
              label="Título"
              :rules="
                rules.required.concat(
                  [rules.requiredTrim(tituloNota)],
                  [rules.maxLength(tituloNota, 200)]
                )
              "
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-menu
              ref="menu-fecha-nota"
              v-model="menuFechaNota"
              :close-on-content-click="false"
              :open-on-click="true"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaNotaSelected"
                  label="Fecha"
                  :append-icon="calendarIcon"
                  v-bind="attrs"
                  outlined
                  clearable
                  dense
                  hint="Formato DD/MM/AAAA"
                  v-mask="'##/##/####'"
                  @blur="fechaNota = parseDateToIso(fechaNotaSelected)"
                  v-on="on"
                  :rules="
                    fechaNotaSelected
                      ? rules.required.concat(rules.validDate)
                      : rules.required
                  "
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaNota"
                no-title
                @change="fechaNotaSelected = formatDate(fechaNota)"
                @input="menuFechaNota = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-textarea
              v-model="observaciones"
              label="Nota"
              dense
              auto-grow
              rows="1"
              :rules="[
                rules.maxLength(observaciones, 1000),
                rules.noStartWithSpaces,
              ]"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mt-n5" outlined @click="close()">
        <span align="center"> Cancelar </span>
      </v-btn>
      <v-btn
        color="primary"
        type="submit"
        class="mt-n5"
        :disabled="!isFormValid"
        form="form"
        :loading="isLoadingSaveBtn"
      >
        <span align="center">Guardar</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import rules from "@/utils/helpers/rules";
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
export default {
  name: "EditNotaCliente",
  directives: { mask },
  props: {
    notaItemToEdit: {
      type: Object,
      required: false,
    },
    clienteId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      formEditTitle: "Nueva nota",
      calendarIcon: "mdi-calendar",
      isFormValid: false,
      rules: rules,
      tituloNota: null,
      observaciones: "",
      isLoadingSaveBtn: false,
      tiposNotasSelected: null,
      tiposNotasItems: [],
      fechaNotaSelected: null,
      menuFechaNota: false,
      fechaNota: null,
    };
  },
  created() {
    this.setPantalla();
  },
  methods: {
    ...mapActions({
      setAlert: "user/setAlert",
      GetTiposNotasClientes: "clientesData/GetTiposNotasClientes",
      saveNotaToCliente: "clientesData/saveNotaToCliente",
    }),
    async setPantalla() {
      const response = await this.GetTiposNotasClientes();
      this.tiposNotasItems = response;
      if (this.notaItemToEdit !== undefined) {
        this.setNotaToEdit(this.notaItemToEdit);
      }
    },
    async setNotaToEdit(item) {
      this.formEditTitle = "Editar nota";
      const itemNota = this.tiposNotasItems.find(
        (x) => x.id == item.tipoNotaId
      );
      this.tiposNotasSelected = itemNota;
      this.fechaNota = this.parseDateToIso(item.fecha);
      this.fechaNotaSelected = item.fecha;
      this.observaciones = item.descripcion;
      this.tituloNota = item.titulo;
    },
    async save() {
      this.isLoadingSaveBtn = true;
      const data = {
        notaId:
          this.notaItemToEdit != undefined ? this.notaItemToEdit.notaId : 0,
        clienteId: this.clienteId,
        tipoNotaId: this.tiposNotasSelected.id,
        observaciones: this.observaciones,
        titulo: this.tituloNota,
        fecha: this.fechaNota,
      };
      try {
        const response = await this.saveNotaToCliente(data);
        if (response.status === 200) {
          this.setAlert({ type: "success", message: "Guardado con éxito." });
          this.$emit("closeAndReload", true);
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingSaveBtn = false;
    },
    close() {
      this.$emit("closeAndReload", false);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length === 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
  },
};
</script>

<style scoped>
</style>